import { render, staticRenderFns } from "./BindsAppSideDrawer.vue?vue&type=template&id=522211b4&"
import script from "./BindsAppSideDrawer.vue?vue&type=script&lang=js&"
export * from "./BindsAppSideDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BindsAppSideDrawer.vue?vue&type=style&index=0&id=522211b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports